import { useEffect, useRef, useState } from 'react';
import { useAppSelector } from './reduxHooks';
import { ThemeConfig } from 'antd';
import { themeObject } from '@app/styles/themes/themeVariables';

// @height-sm: 32px;
// @height-base: 50px;
// @height-lg: 64px;
// const heightBase = 50;
const heightSM = 32;
const heightLG = 64;

export const useThemeWatcher = () => {
  const theme = useAppSelector((state) => state.theme.theme);
  const currentTheme = themeObject[theme as keyof typeof themeObject];
  const root = useRef(document.querySelector(':root'));

  const [themeConfig, setThemeConfig] = useState<ThemeConfig>({});

  useEffect(() => {
    const html = root.current;
    if (html) {
      html.setAttribute('data-no-transition', '');
      html.setAttribute('data-theme', theme);
      // remove transition after layout update
      requestAnimationFrame(() => {
        html.removeAttribute('data-no-transition');
      });
    }

    // ConfigProvider.config({
    //   theme: {
    //     token: {
    //       colorBgContainer: 'red',
    //       colorBgElevated: 'red',
    //     },
    //     primaryColor: currentTheme.primary,
    //     infoColor: currentTheme.primary,
    //     successColor: currentTheme.success,
    //     errorColor: currentTheme.error,
    //     warningColor: currentTheme.warning,
    //   },
    // });
    setThemeConfig({
      token: {
        colorBgContainer: currentTheme.layoutHeaderBg,
        colorPrimaryBg: currentTheme.layoutHeaderBg,
        colorBgBase: currentTheme.background,
        colorBgLayout: currentTheme.layoutBodyBg,

        fontSize: 16,
        fontSizeLG: 16,
        fontFamily: 'Montserrat, sans-serif',
        fontSizeSM: 14,
        borderRadius: 7,
        colorSplit: '#f0f0f0',

        colorPrimary: currentTheme.primary,
        colorInfo: currentTheme.primary,
        colorSuccess: currentTheme.success,
        colorError: currentTheme.error,
        colorWarning: currentTheme.warning,

        colorTextHeading: currentTheme.heading,
        colorTextBase: currentTheme.textMain,
        colorText: currentTheme.textMain,
        colorBorder: currentTheme.borderBase,
        colorIconHover: currentTheme.iconHover,
        colorBgSpotlight: 'rgba(0,0,0,.75)',
        colorBgContainerDisabled: currentTheme.disabledBg,
        colorIcon: currentTheme.icon,

        boxShadow: currentTheme.boxShadow,

        controlHeightLG: 50,
        controlHeight: 50,
        controlHeightSM: 32,
      },
      components: {
        Layout: {
          headerBg: currentTheme.layoutHeaderBg,
          siderBg: currentTheme.layoutSiderBg,
          bodyBg: currentTheme.layoutBodyBg,
          headerHeight: '4.25rem',
          headerPadding: '1rem',
        },
        Menu: {
          iconMarginInlineEnd: '1rem',
          itemMarginInline: 0,
          activeBarWidth: 3,
          itemColor: currentTheme.textSiderSecondary,
        },
        Select: {
          singleItemHeightLG: heightLG,
          optionSelectedFontWeight: 500,
          optionHeight: heightSM,
          optionLineHeight: '22px',
          optionPadding: '5px 12px',
          colorBgContainerDisabled: currentTheme.disable,
        },
        Alert: {
          colorInfoBg: '#dfefff',
        },
        Card: {
          headerPadding: 20,
          headerPaddingSM: 15,
          headerFontSize: 18,
          headerFontSizeSM: 16,
          padding: 20,
          paddingSM: 15,
        },
        Table: {
          borderRadius: 0,
          headerBg: 'transparent',
          colorBgContainer: 'transparent',
          stickyScrollBarBg: currentTheme.scroll,
          colorSplit: 'transparent',
          rowHoverBg: 'transparent',
          headerSortHoverBg: currentTheme.highlightingTableRow,
          controlItemBgActiveHover: currentTheme.highlightingTableRow,
          headerSortActiveBg: 'transparent',
          bodySortBg: 'transparent',
        },
        InputNumber: {
          activeBg: 'transparent',
          colorBgContainer: currentTheme.highlightingDark,
        },
        Input: {
          colorTextPlaceholder: currentTheme.subText,
          colorTextDisabled: currentTheme.disable,
          paddingBlockLG: 11.4,
          fontSizeLG: 16,
          hoverBg: 'transparent',
          activeBg: 'transparent',
        },
        DatePicker: {
          paddingBlock: 11.4,
          fontSizeLG: 16,
          colorBgElevated: currentTheme.background,
          colorTextPlaceholder: currentTheme.subText,
          colorTextDisabled: currentTheme.disable,
          colorBgContainer: currentTheme.highlightingDark,
          colorBorder: 'transparent',
        },
        Modal: {
          colorIconHover: currentTheme.itemHoverBg,
        },
        Button: {
          controlHeightSM: 32,
        },
        // Button: {
        //   colorBgContainerDisabled: currentTheme.disabledBg,
        // },
        // Checkbox: {
        //   bg
        // }
      },
      cssVar: true,
    });
  }, [theme, currentTheme]);

  return themeConfig;
};
